export default __webpack_public_path__ + "b11fa79.png";